/* EveryGlow – cart drawer v2.3 */
(function () {
  if (window.EGCartDrawer) return;
  window.EGCartDrawer = { version: '2.3' };

  var R = window.routes || {};
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ADD = (R.cart_add_url || '/cart/add') + '.js';
  var CHANGE = (R.cart_change_url || '/cart/change') + '.js';
  var UPDATE = (R.cart_update_url || '/cart/update') + '.js';
  var CART = (R.cart_url || '/cart') + '.js';
  var busy = false;
  var tried = {};

  function drawer() { return document.querySelector('cart-drawer'); }
  function inner() { var d = drawer(); return d ? d.querySelector('.drawer__inner') : null; }
  function track(name, payload) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('everyglow_cart_' + name, payload || {}); } catch (e) {}
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || (j && j.status && j.status >= 400)) {
          var err = new Error((j && (j.description || j.message)) || 'Something went wrong. Please try again.');
          err.data = j;
          throw err;
        }
        return j;
      });
    });
  }
  function showError(msg) { var el = document.getElementById('CartDrawer-CartErrors'); if (el) el.textContent = msg || ''; }

  function render(sections) {
    var d = drawer(), dst = inner();
    if (!d || !dst || !sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var src = doc.querySelector('.drawer__inner');
    if (src) dst.innerHTML = src.innerHTML;
    var fresh = doc.querySelector('cart-drawer');
    d.classList.toggle('is-empty', !!(fresh && fresh.classList.contains('is-empty')));
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var b = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (b) bubble.innerHTML = b.innerHTML;
    }
    if (d.classList.contains('active') && typeof trapFocus === 'function') {
      try { trapFocus(document.getElementById('CartDrawer'), inner()); } catch (e) {}
    }
  }

  function refresh() {
    return Promise.all([
      fetch(ROOT + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }),
      fetch(CART, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
    ]).then(function (res) {
      render(res[0]);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: res[1] });
      }
      return res[1];
    });
  }

  function run(task) {
    if (busy) return Promise.resolve();
    busy = true;
    showError('');
    var box = inner();
    if (box) box.classList.add('egc-busy');
    return task()
      .then(refresh)
      .catch(function (e) {
        var msg = (e && e.message) || 'Something went wrong. Please try again.';
        return refresh().catch(function () {}).then(function () { showError(msg); });
      })
      .then(function () {
        busy = false;
        var b = inner();
        if (b) b.classList.remove('egc-busy');
        setTimeout(afterRender, 0);
      });
  }

  function addItems(items, giftId, label) {
    var withGift = items.slice();
    if (giftId) withGift.push({ id: Number(giftId), quantity: 1, properties: { _gift: label } });
    return post(ADD, { items: withGift }).catch(function (e) {
      if (!giftId) throw e;
      return post(ADD, { items: items });
    });
  }

  function needShade(card, sel) {
    sel.classList.add('egc-need');
    var hint = card.querySelector('[data-egc-hint]');
    if (hint) hint.hidden = false;
    sel.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-egc-action]') : null;
    if (!t || !t.closest('cart-drawer')) return;
    e.preventDefault();
    var action = t.getAttribute('data-egc-action');

    if (action === 'remove-pack') {
      var updates = {};
      (t.getAttribute('data-keys') || '').split(',').forEach(function (k) { if (k) updates[k] = 0; });
      track('pack_removed', {});
      run(function () { return post(UPDATE, { updates: updates }); });
      return;
    }

    if (action === 'set-qty') {
      var lk = t.getAttribute('data-key'), lq = Number(t.getAttribute('data-qty')) || 0;
      if (!lk || !lq) return;
      track('upsell_qty', { quantity: lq, offer: t.getAttribute('data-label') || '' });
      run(function () { return post(CHANGE, { id: lk, quantity: lq }); });
      return;
    }

    var card = t.closest('[data-egc-upsell]');
    var sel = card ? card.querySelector('[data-egc-upsell-shade]') : null;
    if (!card || !sel) return;
    if (!sel.value) { needShade(card, sel); return; }

    if (action === 'upgrade') {
      var add = Number(t.getAttribute('data-add')) || 0, label = t.getAttribute('data-label') || '';
      if (!add) return;
      track('upgrade_added', { units: add, offer: label, variant_id: Number(sel.value), gift: !!t.getAttribute('data-gift') });
      run(function () { return addItems([{ id: Number(sel.value), quantity: add, properties: { _bundle: label } }], t.getAttribute('data-gift'), label); });
    } else if (action === 'cross') {
      var r = card.querySelector('input[name="egc-pack"]:checked');
      if (!r) return;
      var units = Number(r.value) || 2, lab = r.getAttribute('data-label') || '';
      track('crosssell_added', { units: units, offer: lab, variant_id: Number(sel.value), gift: !!r.getAttribute('data-gift') });
      run(function () { return addItems([{ id: Number(sel.value), quantity: units, properties: { _bundle: lab } }], r.getAttribute('data-gift'), lab); });
    }
  });

  /* capture phase: keeps these controls away from cart-drawer-items' quantity "change" handler */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('cart-drawer')) return;

    if (t.hasAttribute('data-egc-shade')) {
      e.stopPropagation();
      var keys = (t.getAttribute('data-egc-shade') || '').split(',').filter(Boolean), qty = Number(t.getAttribute('data-qty')) || 1, cur = t.getAttribute('data-current');
      if (!t.value || t.value === cur || !keys.length) return;
      var props = {};
      try { props = JSON.parse(t.getAttribute('data-props') || '{}') || {}; } catch (x) { props = {}; }
      if (Array.isArray(props)) props = {};
      track('shade_changed', { from: Number(cur), to: Number(t.value), quantity: qty });
      var next = Number(t.value);
      run(function () {
        var updates = {};
        keys.forEach(function (k) { updates[k] = 0; });
        return post(UPDATE, { updates: updates }).then(function () {
          return post(ADD, { items: [{ id: next, quantity: qty, properties: props }] }).catch(function (err) {
            return post(ADD, { items: [{ id: Number(cur), quantity: qty, properties: props }] }).then(function () { throw err; });
          });
        });
      });
      return;
    }

    var card = t.closest('[data-egc-upsell]');
    if (!card) return;
    e.stopPropagation();
    if (t.hasAttribute('data-egc-upsell-shade') && t.value) {
      t.classList.remove('egc-need');
      var hint = card.querySelector('[data-egc-hint]');
      if (hint) hint.hidden = true;
    }
    if (t.name === 'egc-pack') {
      var btn = card.querySelector('[data-egc-action="cross"]');
      if (btn) btn.textContent = 'Add · ' + (t.getAttribute('data-price') || '');
    }
  }, true);

  /* gift Brow Gel: removed when the pack no longer qualifies (on the balm page the bundle snippet's syncGift does it) */
  function checkGift() {
    if (busy) return;
    if (document.querySelector('[data-egb]')) return;
    var d = drawer();
    var o = d ? d.querySelector('[data-egc-gift-orphan]') : null;
    if (!o) return;
    var key = o.getAttribute('data-egc-gift-orphan');
    if (!key || tried[key]) return;
    tried[key] = 1;
    run(function () { return post(CHANGE, { id: key, quantity: 0 }); });
  }
  function syncCount() {
    var d = drawer();
    if (!d) return;
    var f = d.querySelector('.cart-drawer__footer[data-egc-count]'), h = d.querySelector('[data-egc-count-label]');
    if (!f || !h) return;
    var n = Number(f.getAttribute('data-egc-count')) || 0;
    var txt = n + (n === 1 ? ' item' : ' items');
    if (h.textContent !== txt) h.textContent = txt;
  }
  function afterRender() { syncCount(); checkGift(); }

  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(afterRender, 80); }
  var el = drawer();
  if (el && window.MutationObserver) new MutationObserver(schedule).observe(el, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', afterRender); else afterRender();
})();
